import { Command, TextSelection } from 'prosemirror-state'

import { schema } from '@showrunner/prose-schemas'

import { titlePageViewPluginKey } from './titlePageViewPlugin'

const FIRST_NODE_POS = 2

/**
 * Select all content within the title page when viewing it.
 * Returns false if not showing title page, allowing other handlers to take over.
 */
const selectAllTitlePage: Command = (state, dispatch) => {
  const { doc, tr } = state

  const pluginState = titlePageViewPluginKey.getState(state)
  if (!pluginState?.showTitlePageView) return false

  const titlePage = doc.firstChild
  if (!titlePage || titlePage.type !== schema.nodes.titlePage) return false

  const startPos = FIRST_NODE_POS
  const endPos = titlePage.nodeSize - FIRST_NODE_POS

  const start = doc.resolve(startPos)
  const end = doc.resolve(endPos)

  tr.setSelection(new TextSelection(start, end))
  dispatch?.(tr)

  return true
}

/**
 * Select all content after the title page.
 * Returns false if showing title page, allowing selectAllTitlePage to take over.
 */
const selectAllCurrentPage: Command = (state, dispatch) => {
  const { doc, tr } = state

  const pluginState = titlePageViewPluginKey.getState(state)
  if (pluginState?.showTitlePageView) return false

  const titlePage = doc.firstChild
  if (!titlePage || titlePage.type !== schema.nodes.titlePage) return false

  const startPos = titlePage.nodeSize
  const endPos = doc.content.size - 2

  if (startPos >= endPos) return false

  const start = doc.resolve(startPos)
  const end = doc.resolve(endPos)

  tr.setSelection(new TextSelection(start, end))
  dispatch?.(tr)

  return true
}

/**
 * Composed select all handler that works for both title page and main content.
 */
export const selectAll: Command = (state, dispatch, view) => {
  return (
    selectAllTitlePage(state, dispatch, view) ||
    selectAllCurrentPage(state, dispatch, view)
  )
}
